module.exports = __webpack_public_path__ + "static/media/majorF6.4e1effe.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/sing/majorF6.wav
// module id = eZIH
// module chunks = 0